<template>
  <qc-container title="编辑实体店" show-divider show-return>
    <el-form ref="editShopForm" inline="true" :model="resetObj" label-width="100px">
      <div class="title">账号信息</div>
      <template v-if="!$route.query.id">
        <form-item-rule label="门店类型" prop="storeType">
          <simple-btn v-model="resetObj.storeType"
                      :init-options="[{label:'实体店',value:'0'},{label:'洗消店',value:'1'}]"></simple-btn>
        </form-item-rule>
        <form-item-rule label="登录账号" prop="userName">
          <el-input placeholder="请输入登录账号" class="w300" v-model="resetObj.userName"></el-input>
        </form-item-rule>
        <form-item-rule label="手机号码" prop="phone">
          <el-input placeholder="请输入手机号码" class="w300" v-model="resetObj.phone"></el-input>
        </form-item-rule>
        <form-item-rule label="密码" prop="password">
          <el-input placeholder="请输入密码" type="password" class="w300" v-model="resetObj.password"></el-input>
        </form-item-rule>
      </template>
      <template v-else="">
        <el-form-item label="门店类型">
          <div class="w300">
            <el-tag>{{ resetObj.storeType ? '洗消店' : '实体店' }}</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="登录账号" prop="userName">
          <div class="w300">{{ resetObj.userName }}</div>
        </el-form-item>
        <el-form-item label="手机号码">
          <div class="w300">{{ resetObj.phone }}</div>
        </el-form-item>
        <br/>
      </template>
      <div class="title">门店信息</div>
      <form-item-rule label="门店图片" prop="logo">
        <upload :type="1" :width="300" v-model="resetObj.logo"></upload>
      </form-item-rule>
      <br/>
      <form-item-rule label="门店名称" prop="storeName">
        <el-input placeholder="请输入门店名称" class="w300" v-model="resetObj.storeName"></el-input>
      </form-item-rule>
      <form-item-rule label="门店电话" prop="storePhone">
        <el-input placeholder="请输入门店电话" class="w300" v-model="resetObj.storePhone"></el-input>
      </form-item-rule>
      <form-item-rule label="营业时间" prop="businessTime">
        <el-input placeholder="请输入门店电话" class="w300" v-model="resetObj.businessTime"></el-input>
      </form-item-rule>
      <br/>
      <form-item-rule label="门店定位" prop="longitude">
        <tx-map @change="changeAddress" :lat="resetObj.latitude" :lng="resetObj.longitude"
                :address-text="resetObj.address"></tx-map>
      </form-item-rule>
      <br/>
      <form-item-rule label="省市区">
        <el-input
          disabled
          class="w150"
          v-model="resetObj.province"/>
        <el-input
          disabled
          class="w150"
          v-model="resetObj.city"/>
        <el-input
          disabled
          class="w150"
          v-model="resetObj.region"/>
      </form-item-rule>
      <br>
      <form-item-rule label="门店地址" prop="address">
        <el-input placeholder="请输入门店地址" class="w500" type="textarea" :rows="4"
                  v-model="resetObj.address"></el-input>
      </form-item-rule>

      <!--      <form-item-rule   label="门店地址" prop="address">
              <tx-map @change="changeAddress" :lat="resetObj.latitude" :lng="resetObj.longitude" :address-text="resetObj.address"></tx-map>
      &lt;!&ndash;
              <el-input placeholder="请输入门店地址" class="w800" type="textarea" :maxlength="500" v-model="resetObj.address"></el-input>
      &ndash;&gt;
            </form-item-rule>-->

      <div class="title">公司信息</div>
      <form-item-rule label="公司名称" prop="name">
        <el-input placeholder="请输入公司名称" class="w300" v-model="resetObj.name"></el-input>
      </form-item-rule>
      <form-item-rule label="住所" prop="shopQualifications.address">
        <el-input placeholder="请输入住所" class="w300" v-model="resetObj.shopQualifications.address"></el-input>
      </form-item-rule>
      <form-item-rule label="信用代码" prop="shopQualifications.creditCode">
        <el-input placeholder="请输入信用代码" class="w300" v-model="resetObj.shopQualifications.creditCode"></el-input>
      </form-item-rule>
      <form-item-rule label="有效期" prop="shopQualifications.expireDate">
        <one-date-picker v-model="resetObj.shopQualifications.expireDate" type="date"
                         value-format="YYYY-MM-DD"></one-date-picker>
      </form-item-rule>
      <form-item-rule label="营业执照" prop="shopQualifications.businessLicense">
        <upload :type="1" :width="300" v-model="resetObj.shopQualifications.businessLicense"></upload>
      </form-item-rule>
      <form-item-rule label="开户许可证" prop="shopQualifications.openPermit">
        <upload :type="1" :width="300" v-model="resetObj.shopQualifications.openPermit"></upload>
      </form-item-rule>

      <div class="title">法人信息</div>
      <form-item-rule label="法人" prop="shopQualifications.legalPerson">
        <el-input placeholder="请输入法人" class="w300" v-model="resetObj.shopQualifications.legalPerson"></el-input>
      </form-item-rule>
      <form-item-rule label="身份证号" prop="shopQualifications.identity">
        <el-input placeholder="请输入身份证号" class="w300" v-model="resetObj.shopQualifications.identity"></el-input>
      </form-item-rule>
      <form-item-rule label="联系人" prop="shopQualifications.concatName">
        <el-input placeholder="请输入法人" class="w300" v-model="resetObj.shopQualifications.concatName"></el-input>
      </form-item-rule>
      <form-item-rule label="联系号码" prop="shopQualifications.mobile">
        <el-input placeholder="请输入法人" class="w300" v-model="resetObj.shopQualifications.mobile"></el-input>
      </form-item-rule>
      <br/>
      <form-item-rule label="身份证正面" prop="shopQualifications.identityLeft">
        <upload :type="1" :width="300" v-model="resetObj.shopQualifications.identityLeft"></upload>
      </form-item-rule>
      <form-item-rule label="身份证反面" prop="shopQualifications.identityRight">
        <upload :type="1" :width="300" v-model="resetObj.shopQualifications.identityRight"></upload>
      </form-item-rule>

      <div class="title">权限管理</div>
      <form-item-rule label="修改商品金额" prop="editMoneyStatus">
        <simple-btn v-model="resetObj.editMoneyStatus"
                    :init-options="[{label:'否',value:'0'},{label:'是',value:'1'}]"></simple-btn>
      </form-item-rule>
      <div class="flex-c">
        <el-form-item class="tc pt20">
          <el-button @click="returnLast()">返回</el-button>
          <el-button type="primary" @click="save()">保存</el-button>
        </el-form-item>
      </div>
    </el-form>

  </qc-container>
</template>

<script>

import QcContainer from '@/components/el/layout/qc-container.vue'
import FormItemRule from '@/components/el/form-item-rule.vue'
import OneDatePicker from '@/components/base/OneDatePicker.vue'
import Upload from '@/components/upload/upload.vue'
import SimpleDictRadio from '@/components/dict/SimpleDictRadio.vue'
import SimpleBtn from '@/components/base/simple-btn.vue'
import TxMap from '@/components/base/tx-map.vue'

export default {
  name: 'add',
  components: {
    TxMap,
    SimpleBtn,
    SimpleDictRadio,
    Upload,
    OneDatePicker,
    FormItemRule,
    QcContainer
  },
  data () {
    return {
      resetObj: {
        userName: '',
        name: '',
        phone: '',
        concatName: '',
        password: '',
        type: 1,
        storeType: 0,
        address: '',
        province: '',
        city: '',
        region: '',
        storeName: '',
        longitude: '',
        latitude: '',
        storePhone: '',
        businessTime: '',
        logo: '',
        editMoneyStatus: '0',
        shopQualifications: {
          businessLicense: '',
          openPermit: '',
          identity: '',
          legalPerson: '',
          concatName: '',
          identityLeft: '',
          identityRight: '',
          creditCode: '',
          expireDate: '',
          address: '',
          mobile: ''
        }
      }
    }
  },
  mixins: [tableBase],
  methods: {
    changeAddress ({
      address,
      lng,
      lat,
      province,
      city,
      region
    }) {
      this.resetObj.province = province
      this.resetObj.city = city
      this.resetObj.region = region
      this.resetObj.address = address
      this.resetObj.longitude = lng
      this.resetObj.latitude = lat
    },
    save () {
      this.$refs['editShopForm'].validate((valid) => {
        if (valid) {
          this.resetObj.contentType = _CONTENT_TYPE_JSON
          let url
          if (this.$route.query.id) {
            url = '/api/mgr/business/shop/updateShop'
          } else {
            url = '/api/mgr/business/shop/addShop'
          }
          this.simplePost(url, this.resetObj, result => {
            this.returnLast()
          })
        }
      })
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.simplePost('/api/mgr/business/shop/getShopDetail', { id: this.$route.query.id }, result => {
        this.resetObj = result.data
      })
    }
  }
}
</script>


<style lang="less" scoped>
.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}

.w300 {
  font-size: 14px;
  vertical-align: middle;
}
</style>
